import Vue from 'vue'
import Router from 'vue-router';
import Axios from 'axios';
import router from '@/router';
import i18n from '@/i18n';
import store from '@/store'
import { StorageService } from "@/services/storage.service";
import ApiService from "@/services/api.service";
import App from '@/App.vue'
import VueAnalytics from "vue-analytics";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faThumbsUp, faThumbsDown, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faThumbsUp);
library.add(faThumbsDown);
library.add(faQuestionCircle);

Vue.component('font-awesome-icon', FontAwesomeIcon);


import './filters/formatDate';
import './filters/formatCurrencyEuro';

ApiService.init(process.env.VUE_APP_API_URL);

if (StorageService.getToken()) {
  ApiService.setHeader();
}

Vue.prototype.$http = Axios;
Vue.config.productionTip = false;

Vue.use(Router);

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID,
  router
});

const app = new Vue({
  render: h => h(App),
  store,
  i18n,
  router
});
store.$app = app;
app.$mount('#app')
